import React, { useEffect } from "react";
import Loadable from "@loadable/component"
import SEO from "../components/seo"
import Header from '../components/Header/Header';
import Banner from '../components/Home/Banner/HomeBanner';
import FAQSchema from "./Seo/FaqSchemaBuilder";
import useInteractionReady from "../utils/use-interaction-ready";

// Always render — above fold or first visible section on scroll
import About from '../components/Home/About/About';
const GetKnow = Loadable(() => import("../components/Home/GetKnow/GetKnow"))

// Below-fold — all deferred until interaction / idle
const Footer = Loadable(() => import("../components/Footer/Footer"))
const OurNetwork = Loadable(() => import("../components/Home/OurNetwork/OurNetwork"))
const ServiceContentOne = Loadable(() => import("../components/AreaGuideDetails/About/About"))
const ServiceContentTwo = Loadable(() => import("../components/AreaGuideDetails/OurMortgage/OurMortgage"))
const WhyUse = Loadable(() => import("../components/WhyUse/WhyUse"))
const Benefits = Loadable(() => import("../components/WhyUse/Benefits"))
const StaticContent = Loadable(() => import("../components/StaticContent/StaticContent"))
const FAQSection = Loadable(() => import("../components/FAQ/FAQSection"))
const GuidesSection = Loadable(() => import("../components/Guides/HandyGuides"))
const StaticContentSidebar = Loadable(() => import("../components/StaticContent/StaticContentSidebar"))
const AccordionModule = Loadable(() => import("../components/Accordion/Accordion"))
const CaseStudySection = Loadable(() => import("../components/CaseStudies/LatestCaseStudies"))
const Accreditations = Loadable(() => import("../components/Accreditations/Accreditations"))
const Brands = Loadable(() => import("../components/AreaGuideDetails/OurBrands/OurBrands"))
const MultiContent = Loadable(() => import("../components/Home/About/MultiRowsContent"))
const Disclaimer = Loadable(() => import("../components/Disclaimer/Disclaimer"))
const NewsInsights = Loadable(() => import("../components/Home/NewsInsights/NewsInsights"))
const FormBlock = Loadable(() => import("../components/Home/FormBlock/FormBlock"))
const CountBlock = Loadable(() => import("../components/Home/CountBlock/CountBlock"))
const GlobalCount = Loadable(() => import("../components/Home/CountBlock/GlobalCount"))
const CountBlockLeftContent = Loadable(() => import("../components/Home/CountBlock/CountBlockLeftContent"))
const BookValuation = Loadable(() => import("../components/Home/BookValuation/BookValuation"))
const MarketingCard = Loadable(() => import("../components/MarketingCard/MarketingCard"))

const HomeModules = (props) => {

    // Fires on first mousemove / touchstart / scroll / keydown, or after 4s idle
    const renderComponent = useInteractionReady()

    useEffect(() => {
        const pageurl = typeof window !== 'undefined' ? window.location.pathname : ''
        if (window) {
            window.history.pushState({}, "", pageurl.split("?")[0]);
        }
    }, [])


    return (
        <React.Fragment>
            <SEO title={props.page.Meta_Title} description={props.page.Meta_Description} image={props.page.Banner_Image ? props.page.Banner_Image.url : ''} />

            <FAQSchema
                modules={props.modules}
                enabled={true}
            />
            <div className={props.page.Layout === 'Homepage' ? "home-header" : props.page.Layout === 'Default' ? 'wrapper area-guide-wrapper' : props.page.Layout === 'Staticpage' || props.page.Layout === 'Valuation' || props.page.Layout === 'Background_Image_Layout' || props.page.Layout === 'Calculator_or_Form' ? 'wrapper static-page' : ''}>
                <Header isHomePage={true} />

                {props.page.Layout === 'Homepage' && props.page.Banner_Image && props.page.Choose_Menu[0].URL === 'home' &&
                    <Banner {...props.page} />
                }

                {props.page.Layout === 'Homepage' && props.page.Banner_Image && props.page.Choose_Menu[0].URL !== 'home' &&
                    <Banner {...props.page} />
                }
            </div>

            {props.modules && props.modules.map((module, i) => {
                return (
                    <React.Fragment key={i}>

                        {/* ── Above fold / first visible on scroll — render immediately ── */}

                        {module.Intro_Content &&
                            <About {...module} />
                        }

                        {module.Add_Service_Tile &&
                            <GetKnow {...module} />
                        }

                        {/* ── Below fold — gate on first interaction ── */}

                        {module.Add_Stats && renderComponent &&
                            <>
                                {module.Statistics_Left_Content ?
                                    <CountBlockLeftContent {...module} /> : <CountBlock {...module} />
                                }
                            </>
                        }

                        {module.Marketing_Card_Title && module.Marketing_Card_CTA_Link && renderComponent &&
                            <MarketingCard {...module} />
                        }

                        {module.Select_Module && module.Select_Module.CTA_1_Link == null && renderComponent &&
                            <FormBlock {...module.Select_Module} />
                        }

                        {module.Select_Module && module.Select_Module.CTA_1_Link && renderComponent &&
                            <BookValuation {...module.Select_Module} />
                        }

                        {module.Latest_News_Heading && module.Latest_News_Intro_Content && renderComponent &&
                            <NewsInsights {...module} />
                        }

                        {module.Add_New_Block && renderComponent &&
                            <>
                                {module.Add_New_Block.length >= 3 ?
                                    <>
                                        {module.Add_New_Block && module.Add_New_Block.slice(0, 1).map((service, j) => (
                                            <ServiceContentOne key={j} {...service} service_length={module.Add_New_Block.length} />
                                        ))}
                                        {module.Add_New_Block.length > 1 &&
                                            <ServiceContentTwo {...module} />
                                        }
                                    </> : module.Add_New_Block.length == 2 ?
                                        <ServiceContentTwo {...module} cut="0" /> :
                                        <>
                                            {module.Add_New_Block && module.Add_New_Block.slice(0, 1).map((service, j) => (
                                                <ServiceContentOne key={j} {...service} service_length={module.Add_New_Block.length} />
                                            ))}
                                        </>
                                }
                            </>
                        }

                        {module.Choose_Module === "Our_Network" && renderComponent &&
                            <OurNetwork {...props} />
                        }

                        {module.Choose_Module === "Why_Use" && renderComponent &&
                            <WhyUse />
                        }

                        {module.Add_Benefit && renderComponent &&
                            <Benefits {...module} />
                        }

                        {module.Add_Static_Content && renderComponent &&
                            <>
                                {module.Style == 'With_Sidebar' ?
                                    <StaticContentSidebar layout={props.page.Layout} {...module} {...props.page} count={i} />
                                    : <StaticContent {...module} style={module.Style} count={i} />
                                }
                            </>
                        }

                        {module.Add_Brand && renderComponent &&
                            <Brands {...module} />
                        }

                        {module.Select_FAQs && renderComponent &&
                            <FAQSection {...module} />
                        }

                        {module.Add_Accordion && renderComponent &&
                            <AccordionModule {...module} />
                        }

                        {module.Select_Guides_here && renderComponent &&
                            <GuidesSection {...module} />
                        }

                        {module.Select_Case_Studies_to_Show && renderComponent &&
                            <CaseStudySection {...module} />
                        }

                        {module.Add_Accreditation && renderComponent &&
                            <Accreditations {...module} />
                        }

                        {module.Stats_Title && renderComponent &&
                            <GlobalCount {...module} />
                        }

                        {module.Add_New_Column && props.page.Layout !== 'Background_Image_Layout' && renderComponent &&
                            <MultiContent {...module} />
                        }

                        {module.Add_Disclaimer_Content && renderComponent &&
                            <Disclaimer {...module} />
                        }

                    </React.Fragment>
                )
            })}

            {renderComponent &&
                <Footer search={props.page.Popular_Search} />
            }
        </React.Fragment>
    )
}
export default HomeModules;
